
import { Component, Prop, Vue } from 'vue-property-decorator';
import MainMenuItemEntity from '@/entities/MainMenuItemEntity';

@Component
export default class TheMainMenuItem extends Vue {
  @Prop({ type: Object, required: true }) readonly item!: MainMenuItemEntity;
}
